@let top10Videos = top10Videos$ | async;
@let landscapes = landscapes$ | async;
@let regions = regions$ | async;
@let homeVideos = homeVideos$ | async;
@let homePlaylists = homePlaylists$ | async;
@let recommendedVideos = recommendedVideos$ | async;

<div class="catalog-video">
  @if (displayMode === 'home') {
    <ng-container>
      @if (recommendedVideos?.length) {
        <div class="section">
          <div class="section-title">
            <span class="title">
              {{ 'browse.recommended.title' | translate }}
            </span>
          </div>
          <app-browse-carousel
            [itemType]="CarouselItem.VideoDetail"
            [videos]="recommendedVideos" />
        </div>
      }
      @if (top10Videos?.length) {
        <div class="section">
          <div class="section-title">
            <span class="title">{{ 'browse.top10.title' | translate }}</span>
          </div>
          <app-browse-carousel
            [itemType]="CarouselItem.VideoPoster"
            [videos]="top10Videos" />
        </div>
      }
      @if (landscapes?.length || regions?.length) {
        <div class="section">
          <div class="section-title">
            <span class="title">
              {{ 'browse.landscapesAndRegions.title' | translate }}
            </span>
          </div>
          <app-double-carousel [landscapes]="landscapes" [regions]="regions" />
        </div>
      }
      @if (homeVideos?.length) {
        <div class="section">
          <div class="section-title">
            <span class="title">
              {{ 'browse.allVideos.title' | translate }}
            </span>
            <a
              [routerLink]="['/browse?location=video']"
              class="see-all"
              (click)="onSwitchDisplayMode('video')">
              <span> {{ 'browse.seeAll' | translate }} </span>
              <span class="icon icon-arrow-right"></span>
            </a>
          </div>
          <app-browse-carousel
            [itemType]="CarouselItem.VideoDetail"
            [videos]="homeVideos$ | async" />
        </div>
      }
      @if (homePlaylists?.length) {
        <div class="section">
          <div class="section-title">
            <span class="title">
              {{ 'browse.playlists.title' | translate }}
            </span>
            <a
              href="/browse?location=playlist"
              class="see-all"
              (click)="onSwitchDisplayMode('playlist')">
              <span> {{ 'browse.seeAll' | translate }} </span>
              <span class="icon icon-arrow-right"></span>
            </a>
          </div>
          <app-browse-carousel
            [itemType]="CarouselItem.Playlist"
            [playlists]="homePlaylists" />
        </div>
      }
    </ng-container>
  } @else {
    <ng-container>
      <div class="back-btn-wrapper">
        <app-back-button
          [hasLinkStyle]="true"
          (goBack)="onSwitchDisplayMode('home')" />
      </div>
      <app-listing
        [modeName]="ModeNames.Videos"
        [contentType]="
          displayMode === 'video' ? ContentTypes.Video : ContentTypes.Playlist
        " />
    </ng-container>
  }
</div>
